module.exports = __webpack_public_path__ + "img/valueResultContBj.0bf4b46c.png";